// server status for internal use, RfiStatus is the enum for external usage
export enum RfiStatus {
  Draft = 'draft',
  Submitted = 'submitted',
  Open = 'open',
  OpenRev1 = 'openRev1',
  OpenRev2 = 'openRev2',
  Answered = 'answered',
  AnsweredRev1 = 'answeredRev1',
  AnsweredManager = 'answeredManager',
  Closed = 'closed',
  Void = 'void',
}

/**
 * The cost impact status of the RFI. Possible values: ``Yes``, ``No``, ``Unknown``.
 * @export
 * @enum {string}
 */
export enum RfiCostImpact {
  Yes = 'Yes',
  No = 'No',
  Unknown = 'Unknown',
}
/**
 * The schedule impact status of the RFI. Possible values: ``Yes``, ``No``, ``Unknown``.
 * @export
 * @enum {string}
 */
export enum RfiScheduleImpact {
  Yes = 'Yes',
  No = 'No',
  Unknown = 'Unknown',
}
/**
 * The priority status of the RFI. Possible values: ``High``, ``Normal``, ``Low``.
 * @export
 * @enum {string}
 */
export enum RfiPriority {
  High = 'High',
  Normal = 'Normal',
  Low = 'Low',
}

/**
 * The disciplines of the RFI
 * @export
 * @enum {string}
 */
export enum RfiDiscipline {
  Architectural = 'Architectural',
  AudioVisual = 'Audio Visual',
  BuildingManagementSystem = 'Building Management System',
  Cabling = 'Cabling',
  CivilSite = 'Civil/Site',
  Concrete = 'Concrete',
  DesignSystemsIntegrator = 'Design Systems Integrator',
  DistributedAntennaSystem = 'Distributed Antenna System',
  Electrical = 'Electrical',
  ElectricalSubstation = 'Electrical Substation',
  ExteriorEnvelope = 'Exterior Envelope',
  FireAlarm = 'Fire Alarm',
  FireProtection = 'Fire Protection',
  FoodService = 'Food Service',
  InteriorFinishes = 'Interior/Finishes',
  Landscaping = 'Landscaping',
  Lighting = 'Lighting',
  Masonry = 'Masonry',
  Mechanical = 'Mechanical',
  Networks = 'Networks',
  Pathways = 'Pathways',
  Plumbing = 'Plumbing',
  PowerSystems = 'Power Systems',
  Roofing = 'Roofing',
  Security = 'Security',
  Signage = 'Signage',
  Structural = 'Structural',
  VerticalTransportation = 'Vertical Transportation',
  Other = 'Other',
}

/**
 * The categories of the RFI
 * @export
 * @enum {string}
 */
export enum RfiCategory {
  CodeCompliance = 'Code Compliance',
  Constructability = 'Constructability',
  DesignCoordination = 'Design Coordination',
  DocumentationConflict = 'Documentation Conflict',
  DocumentationIncomplete = 'Documentation Incomplete',
  Fieldcondition = 'Field condition',
  Other = 'Other',
}

export enum RfiBridgedFilterOptions {
  Yes = 'Yes',
  No = 'No',
}

export enum UserRole {
  projectUser = 'project_user',
  projectAdmin = 'project_admin',
}

export enum WorkflowType {
  US = 'US',
  EU = 'EU',
}

export enum WorkflowRole {
  ProjectSC = 'projectSC',
  ProjectGC = 'projectGC',
  ProjectCoordinator = 'projectCoordinator',
  ProjectReviewer = 'projectReviewer',
}

export enum Order {
  DESC = 'DESC',
  ASC = 'ASC',
}

export enum ResponseStatus {
  Answered = 'answered',
  Rejected = 'rejected',
}

export enum ResponseState {
  Submitted = 'submitted',
  Draft = 'draft',
}

/**
 * The reviewer type of an RFI response, distinguishing required-reviewer
 * responses from optional-reviewer responses.
 * @export
 * @enum {string}
 */
export enum ReviewerType {
  Required = 'required',
  Optional = 'optional',
}
